import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  getConcerningTrendingOnly,
  getCurrentDispatcherTestsOnly,
  getDispatcherType,
  getPanelsOpenStatus,
  getScenariosByDispatcherId,
  jobScenariosReducer,
  routerExtraReducer
} from './../reducers';
import {
  scenario as scenarioSelectors,
  dispatcher as dispatcherSelectors,
  regressionPage as regressionPageSelectors
} from '../selectors';

import {
  dispatcherTypes, regressionPages,
  commonPageInfo as commonPageHelpers
} from './../helpers';
import { uniq } from 'lodash';
import RegressionViewComponent from './../Components/RegressionViewComponent.jsx';
import ConditionalComponent from '../Components/ConditionalComponent';

import {
  builds as buildActions,
  fetchScenariosByDispatcherIds,
  fetchJobBuilds,
  jobRelationships as jobRelationshipActions,
  jobs as jobActions,
  metrics as metricsActions,
  params as paramActions,
  setSearchTerm,
  setConcerningTrendingOnly,
  setCurrentDispatcherTestsOnly,
  setActiveTab
} from './../actions';

export class RegressionViewContainer extends Component {
  static propTypes = {
    fetchScenariosByDispatcherIds: PropTypes.func.isRequired,
    fetchParamsByJobIds: PropTypes.func.isRequired,
    fetchMetricsByJobIds: PropTypes.func.isRequired,
    fetchJobsByJobIds: PropTypes.func.isRequired,
    fetchJobScenariosByScenarioIds: PropTypes.func.isRequired,
    scenarios: PropTypes.array,
    jobScenarioJobIds: PropTypes.array,
    nonEmptyRunnerScenarios: PropTypes.array,
    jobInfo: PropTypes.shape({
      dispatcherId: PropTypes.oneOfType[
        PropTypes.string, PropTypes.number],
      jobId: PropTypes.oneOfType[
        PropTypes.string, PropTypes.number],
    }).isRequired,
    dispatcherIds: PropTypes.array,
    metricsByJobIds: PropTypes.object,
    reducedHeaders: PropTypes.array.isRequired,
    trendingHeaders: PropTypes.array.isRequired,
    dispatcherType: PropTypes.string.isRequired,
    installerPage: PropTypes.bool.isRequired,
    concerningTrendingOnly: PropTypes.bool,
    currentDispatcherTestsOnly: PropTypes.bool,
    setConcerningTrendingOnly: PropTypes.func.isRequired,
    setCurrentDispatcherTestsOnly: PropTypes.func.isRequired,
    fetchBuilds: PropTypes.func.isRequired,
    fetchJobBuilds: PropTypes.func.isRequired,
    trendingRunnerIds: PropTypes.array.isRequired,
    trendingPanelOpenStatus: PropTypes.bool,
    allDispatcherIds: PropTypes.array,
    allScenarios: PropTypes.array,
    onClickTab: PropTypes.func.isRequired,
    tabInURL: PropTypes.string.isRequired
  };

  componentDidUpdate() {

    if (this.props.tabInURL === commonPageHelpers.FAILURE_TRENDS) {
      if (this.props.allDispatcherIds.length > 0) {
        this.props.fetchScenariosByDispatcherIds(this.props.allDispatcherIds);
        const allScenarioIds = this.props.allScenarios.map(s => s.runner).filter(x => x);
        this.props.fetchParamsByJobIds(allScenarioIds);
      }
    }

    if (!this.props.jobInfo.dispatcherId) {
      return;
    }

    this.props.fetchScenariosByDispatcherIds([this.props.jobInfo.dispatcherId]);

    if (!this.props.installerPage) {
      this.props.fetchScenariosByDispatcherIds(this.props.dispatcherIds);
    }

    if (this.props.scenarios === undefined || this.props.scenarios.length === 0) {
      return;
    }

    if (this.props.nonEmptyRunnerScenarios === undefined ||
      this.props.nonEmptyRunnerScenarios.length === 0) {
      return;
    }

    const jobIds = uniq([...this.props.nonEmptyRunnerScenarios.map(s => s.runner), this.
      props.jobInfo.jobId, ...this.props.jobScenarioJobIds]).filter(x => x);
    const scenarioIds = this.props.scenarios.map(s => s.id);
    this.props.fetchJobScenariosByScenarioIds(scenarioIds);
    this.props.fetchMetricsByJobIds(jobIds);
    this.props.fetchBuilds(regressionPages.FETCH_DAYS);
    this.props.fetchJobBuilds(regressionPages.FETCH_DAYS);
    this.props.fetchParamsByJobIds(jobIds);
    this.props.fetchJobsByJobIds(jobIds);

    if (this.props.trendingPanelOpenStatus) {
      this.props.fetchParamsByJobIds(uniq(this.props.trendingRunnerIds));
      this.props.fetchJobsByJobIds(uniq(this.props.trendingRunnerIds));
    }
  }

  render() {
    return (
      <ConditionalComponent
        condition={!!this.props.scenarios}
        children={
          <RegressionViewComponent {...this.props} />
        }
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  const dispatcherId = ownProps.jobInfo && ownProps.jobInfo.dispatcherId;
  const dispatcherScenarios = getScenariosByDispatcherId(state, dispatcherId) || [];
  let jobScenarios = [];
  dispatcherScenarios.map(s => jobScenarios =
    jobScenarios.concat(jobScenariosReducer.getJobScenariosByScenarioId(state, s.id)));
  const jobScenarioJobIds =
    jobScenarios.filter(x => x).map(jobScenario => jobScenario.job_id);

  const nonEmptyRunnerScenarios = dispatcherScenarios ?
    dispatcherScenarios.filter(s => s.runner) : [];

  const allDispatcherIds = dispatcherSelectors.recentDispatchersAndJobsByName(state)
    .dispatchers[ownProps.jobInfo.jobName] ?
    dispatcherSelectors.recentDispatchersAndJobsByName(state)
      .dispatchers[ownProps.jobInfo.jobName].map((d) => d.id) : [];

  const allScenarios = allDispatcherIds.reduce(
    (result, id) => result.concat(getScenariosByDispatcherId(state, id) || []),
    []
  );
  const panelsOpenStatus = getPanelsOpenStatus(state) || {};
  const trendingPanelOpenStatus = panelsOpenStatus['Trending'];
  const trendingRunnerIds = trendingPanelOpenStatus ?
    scenarioSelectors.getTrendingRunnerIds(state) :
    [];
  const tabInURL = routerExtraReducer.getQueryParam(state, 'tab');

  const props = {
    dispatcherIds: trendingPanelOpenStatus ?
      dispatcherSelectors.getDispatcherIds(state) :
      dispatcherSelectors.getRecentDispatcherIds(state),
    scenariosOfSelectedDispatcher: dispatcherScenarios,
    scenarios: dispatcherScenarios,
    jobScenarioJobIds,
    concerningTrendingOnly: getConcerningTrendingOnly(state),
    currentDispatcherTestsOnly: getCurrentDispatcherTestsOnly(state),
    nonEmptyRunnerScenarios,
    reducedHeaders: regressionPageSelectors.getReducedHeaders(state)(false),
    trendingHeaders: regressionPageSelectors.getReducedHeaders(state)(true),
    installerPage: getDispatcherType(state) === dispatcherTypes.INSTALLERTESTS,
    trendingRunnerIds,
    trendingPanelOpenStatus,
    allDispatcherIds,
    allScenarios,
    tabInURL
  };
  return props;
};

export default connect(
  mapStateToProps,
  {
    fetchScenariosByDispatcherIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
    fetchMetricsByJobIds: metricsActions.fetchMetricsByJobIds,
    fetchJobsByJobIds: jobActions.fetchJobsByJobIds,
    fetchBuilds: buildActions.fetchBuilds,
    fetchJobBuilds,
    fetchJobScenariosByScenarioIds: jobRelationshipActions.fetchJobScenariosByScenarioIds,
    onChange: (searchTerm) => setSearchTerm(searchTerm),
    setConcerningTrendingOnly:
      concerningTrendingOnly => setConcerningTrendingOnly(concerningTrendingOnly),
    setCurrentDispatcherTestsOnly:
      currentDispatcherTestsOnly =>
        setCurrentDispatcherTestsOnly(currentDispatcherTestsOnly),
    onClickTab: key => setActiveTab(key)
  }
)(RegressionViewContainer);



// WEBPACK FOOTER //
// src/Containers/RegressionViewContainer.jsx